// @flow strict

import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { MicroFrontEnds } from '../../microfrontendURIs';

import MicroFrontend from '..';
import { ContainerCentered } from 'styles/common';
import ErrorMessage from 'components/ErrorMessage';

import type { IntlType } from 'types';
import { selectUserTimezone } from '../../services/Authentication/selectors';

type Props = {
    intl: IntlType,
    userTimezone: string,
};

type State = {
    isUnLoadable: boolean,
};

class PlatformAuthenticationLogin extends React.PureComponent<Props, State> {
    state = {
        isUnLoadable: false,
    };

    static getHost = () => {
        return MicroFrontEnds.platformAuthenticationLogin; // must match the secret object's structure in GCP
    };

    static getUniqueName = () => {
        return 'PlatformAuthenticationLoginMFE'; // name must match the container name in the MFE code
    };

    getMountProps = () => {
        return {
            locale: this.props.intl.locale.toUpperCase(),
            userTimezone: this.props.userTimezone,
        };
    };

    onError = () => {
        this.setState({ isUnLoadable: true });
    };

    render() {
        if (this.state.isUnLoadable) {
            return (
                <ContainerCentered>
                    <ErrorMessage
                        errorMessage={this.props.intl.formatMessage({
                            id: `views.${PlatformAuthenticationLogin.getUniqueName()}.anErrorOccurredDuringLoad`,
                        })}
                    />
                </ContainerCentered>
            );
        }
        return (
            <MicroFrontend
                name={PlatformAuthenticationLogin.getUniqueName()}
                host={PlatformAuthenticationLogin.getHost()}
                mountedMicroFrontendProps={this.getMountProps()}
                onError={this.onError}
            />
        );
    }
}

const mapStateToProps = () =>
    createStructuredSelector({
        userTimezone: selectUserTimezone(),
    });

export default connect(mapStateToProps)(injectIntl(PlatformAuthenticationLogin));
